@use "variables" as *;

.container {
  position: relative;
  display: flex;
  border-radius: 20px !important;
  .hoverButtonsStack {
    visibility: hidden;
    position: absolute;
    right: 0;
    bottom: 0;
    margin: $spacing-s;
    z-index: 100;
  }
  &:hover .hoverButtonsStack {
    visibility: visible;
  }
}

.rightContainer {
  height: 100%;
  width: 100%;
  margin-top: $spacing-m;
  margin-right: $spacing-s;
}

.defaultIcon {
  display: flex;
  height: 50px;
  width: 70px;
  margin-left: $spacing-s;
  margin-right: $spacing-s;
  align-items: center;
  justify-content: center;
  border-radius: 16px !important;
}

.name {
  font-size: $fontSize-s;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.description {
  white-space: pre-wrap;
  font-size: $fontSize-xxs;
  font-weight: normal;
  margin-bottom: $spacing-s;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.hoverButton {
  width: 30px;
  height: 30px;
  box-shadow: 0 3px 4px 0 rgba(0, 0, 0, 0.25);
}

.hoverButtonIcon {
  width: 20px !important;
  height: 20px !important;
}
